{
  "title": "Groups",
  "description": "Permission groups for dashboard and operator users",
  "actions": {
    "add": "Add Group"
  },
  "columns": {
    "name": "Name",
    "description": "Description",
    "users": "Users",
    "services": "Services",
    "status": "Status"
  },
  "list": {
    "ariaLabel": "Groups",
    "searchPlaceholder": "Search by group name"
  },
  "systemGroupProtected": "The system administrator group cannot be edited or deleted",
  "rowActions": {
    "edit": "Edit",
    "manageServices": "Assign Services",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "delete": "Delete"
  },
  "drawer": {
    "createTitle": "Add Group",
    "editTitle": "Edit Group",
    "fields": {
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "descriptionAr": "Arabic Description",
      "descriptionEn": "English Description"
    },
    "submit": "Save",
    "cancel": "Cancel",
    "discard": {
      "title": "Discard changes?",
      "description": "What you entered for this group will not be saved.",
      "confirmLabel": "Discard",
      "cancelLabel": "Keep editing"
    },
    "created": "Group created successfully",
    "updated": "Group updated successfully"
  },
  "statusConfirm": {
    "activateTitle": "Activate {{name}}?",
    "activateDescription": "This group's users will be able to sign in again.",
    "deactivateTitle": "Deactivate {{name}}?",
    "deactivateDescription": "This group's users will not be able to sign in until it is reactivated.",
    "confirmActivate": "Activate",
    "confirmDeactivate": "Deactivate"
  },
  "deleteConfirm": {
    "title": "Delete {{name}}?",
    "description": "This group will be permanently deleted. This action cannot be undone.",
    "confirm": "Delete"
  },
  "services": {
    "title": "{{group}} services",
    "description": "Select the services this group grants. Selecting an action on an entity automatically selects its view and list services.",
    "autoAddedNote": "Selected automatically because another service on the same entity is enabled",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "searchPlaceholder": "Search for a service",
    "platformAccessTitle": "This group opens:",
    "platformOperator": "Operator card",
    "platformDashboard": "Dashboard card",
    "platformNone": "It does not open any card yet",
    "save": "Save Services",
    "saved": "Permissions saved successfully",
    "systemGroupNotice": "The system administrator group's permissions are fixed and cannot be changed",
    "discard": {
      "title": "Discard changes?",
      "description": "The changes you made to this group's services will not be saved.",
      "confirmLabel": "Discard",
      "cancelLabel": "Keep editing"
    },
    "platformPda": "Fuel - PDA card"
  },
  "toasts": {
    "statusChanged": "Group status changed successfully",
    "deleted": "Group deleted successfully"
  }
}
